// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Switch_wrapper__2a0-A","switch":"Switch_switch__3BCKY","dark":"Switch_dark__1L36p"};